import FeedbackNumberRating from './internal/FeedbackNumberRating';
import { jsx as _jsx } from "react/jsx-runtime";
const CesRating = props => /*#__PURE__*/_jsx(FeedbackNumberRating, Object.assign({
  "data-selenium-test": "feedback-rating-ces",
  min: 1,
  max: 7,
  name: "ces-rating"
}, props));
export default CesRating;